module.exports = __webpack_public_path__ + "7b91af55b8d0b4df6adc4c5d6810037a.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/uikit/assets/font/noto-sans-kr-v11-korean_latin-regular.woff2
// module id = 456
// module chunks = 0